import { extent } from 'd3-array';

import type { InternalTreeMapNode } from '../types/internal.js';

export const getDataExtent = (data: InternalTreeMapNode) => {
  const leafArray: number[] = [];

  data.children?.forEach((cluster) =>
    cluster.children?.forEach((leaf) => leafArray.push(leaf.value)),
  );

  return extent(leafArray, (datum) => datum);
};
